import { FC } from "react";

import StoresSection from "sections/storesPage/StoresSection";

import Layout from "components/Layout";

const StoresPage: FC = () => {
  return (
    <Layout
      subHeader={{
        header: "Stores",
        description:
          "A unique space where brands, projects, influencers and artists can list their phygital NFTs using Uniqly technology. Enter the new wave of NFT-commerce.",
        background: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/subheader/stores.jpg`,
        isBackgroundGradient: true,
      }}
    >
      <StoresSection />
    </Layout>
  );
};

export default StoresPage;
